module.exports = __webpack_public_path__ + "cd455783/img/revit-icon.5ff0d581.svg";